exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\n  display: inline-block;\n  cursor: pointer;\n  padding: 2px 10px;\n  margin: 0 0.25rem;\n  font-size: 1.2em;\n  color: white;\n}\ninput[type=radio]:checked + label {\n  color: white;\n  background: #174656;\n}", ""]);

// exports
